import { s, x } from '../../lit-element.js';
import { o } from '../../unsafe-html.js';
import '../../directive.js';

/**
 * A base component for retrieving content from Chariot CMS.
 *
 *
 */
class RefiChariot extends s {
  constructor() {
    super();
    this.baseUrl = this.baseUrl || RefiChariot.parentURL;
    this.content = null;
    this.contentName = '';
  }

  static get parentURL() {
    return window.location.host.includes(`autorefi.capitalone.com` )
      ? 'https://ecm.capitalone.com/AutoRefinance'
      : 'https://caas-cdn-preview.cloud.capitalone.com/AutoRefinance';
  }

  static get properties() {
    return {
      content: { type: String },
      contentName: { type: String, attribute: 'content-name' },
      contentType: { type: String },
      contentPath: { type: String, attribute: 'content-path' },
      listContentPath: { type: String, attribute: 'list-content-path' },
      baseUrl: { type: String, attribute: 'base-url' },
    };
  }

  async connectedCallback() {
    super.connectedCallback();
    this.contentUrl = `${this.baseUrl}/${this.contentName}`;
    this.contentType = this.getContentType(this.contentName);
    if (this.contentType === 'image') {
      this.content = this.contentUrl;
    } else {
      await this.fetchContent(this.contentUrl, this.contentType, this.contentPath, this.listContentPath);
      this.dispatchEvent(new CustomEvent('contentReady', { detail: this.content }));
    }
  }

  render() {
    return x` ${this.contentType === 'image' ? x`<img src="${this.content}" />` : o(this.availableContent)} `;
  }

  get availableContent() {
    return typeof this.content === 'string' ? this.content : `<slot></slot>`;
  }

  getContentType(contentName) {
    const fileExtension = contentName.split('.').pop();
    switch (fileExtension) {
      case 'jpeg':
      case 'jpg':
      case 'png':
        return 'image';
      default:
        return fileExtension;
    }
  }

  async fetchContent(url, contentType, contentPath, listContentPath) {
    const response = await fetch(url);
    if (contentType === 'json') {
      const cmsData = await response.json();
      this.content = this.parseJsonContentPath(cmsData, contentPath, listContentPath);
    } else {
      this.content = await response.text();
    }
  }

  /**
   * Will retrieve content as the specified path. Path should be in pure "dot form/notation".
   * Example:
   *   Given the object:
   *   {
   *      "parent": [
   *          {labelFirst: "hello"}
   *      ]
   *  }
   *  The contentPath for `labelFirst` would be "parent.0.labelFirst"
   * @param content
   * @param contentKey
   * @param listContentKey
   * @returns {null|*}
   */
  parseJsonContentPath(content, contentKey, listContentKey) {
    if (!(content instanceof Object) || typeof contentKey === 'undefined') {
      throw new Error(`InvalidArgumentException(jsonData: ${content}, path: ${contentKey})`);
    }
    let cmsContent = content;
    const convertIndexesToProperties = ck => ck.replace(/\[(\w+)\]/g, '.$1');
    const stripLeadingDot = ck => ck.replace(/^\./, '');
    let contentDotPath = convertIndexesToProperties(contentKey);
    contentDotPath = stripLeadingDot(contentDotPath);
    const pathArray = contentDotPath.split('.');
    pathArray.forEach(key => {
      if (key in cmsContent) {
        if (cmsContent[key] !== null) {
          cmsContent = cmsContent[key];
        } else {
          cmsContent = null;
        }
      } else {
        cmsContent = key;
      }
    });
    if (listContentKey && Array.isArray(cmsContent)) {
      const currentContentArray = [];
      let listContentDotPath = convertIndexesToProperties(listContentKey);
      listContentDotPath = stripLeadingDot(listContentDotPath);
      const listPathArray = listContentDotPath.split('.');
      cmsContent.forEach(contents => {
        let currentContent = contents;
        listPathArray.forEach(key => {
          if (key in currentContent) {
            if (currentContent[key] !== null) {
              currentContent = currentContent[key];
            } else {
              currentContent = null;
            }
          } else {
            currentContent = key;
          }
        });
        currentContentArray.push(currentContent);
      });
      cmsContent = currentContentArray;
    }
    return cmsContent;
  }
}

export { RefiChariot };
